module.exports = __webpack_public_path__ + "img/8.fa40303d.jpg";